import {
  Directive,
  ElementRef,
  inject,
  input,
  OnChanges,
  Renderer2,
  SimpleChanges
} from '@angular/core';
import { ProductIntegrationStatus } from '../../../../enums';

type NotificationStyle = {
  borderColor: string;
  backgroundColor: string;
  icon: string;
  textColor: string;
};

@Directive({
  selector: '[aionzProductIntegrationNotification]',
  standalone: true,
  exportAs: 'aionzProductIntegrationNotification'
})
export class ProductIntegrationNotificationDirective implements OnChanges {
  private elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  private renderer = inject(Renderer2);

  public status = input.required<ProductIntegrationStatus>();

  private readonly statusToStyle: Record<ProductIntegrationStatus, NotificationStyle> = {
    [ProductIntegrationStatus.INTEGRATION_FAILED]: {
      borderColor: '#D83C38',
      backgroundColor: '#FFF0F0',
      icon: 'error_outline',
      textColor: '#D83C38'
    },
    [ProductIntegrationStatus.PARTIALLY_INTEGRATED]: {
      borderColor: '#9A6704',
      backgroundColor: '#FFF8E1',
      icon: 'info_outline',
      textColor: '#9A6704'
    },
    [ProductIntegrationStatus.SUCCESSFULLY_INTEGRATED]: {
      borderColor: '#33A745',
      backgroundColor: '#EBF8F1',
      icon: 'check_circle_outline',
      textColor: '#33A745'
    }
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['status']) {
      this.updateStyles();
    }
  }

  public getIcon(): string {
    return this.statusToStyle[this.status()]?.icon ?? 'info_outline';
  }

  private updateStyles(): void {
    const style = this.statusToStyle[this.status()];

    if (!style) return;

    this.renderer.setStyle(
      this.elementRef.nativeElement,
      'border',
      `1px solid ${style.borderColor}`
    );
    this.renderer.setStyle(this.elementRef.nativeElement, 'backgroundColor', style.backgroundColor);
    this.renderer.setStyle(this.elementRef.nativeElement, 'color', style.textColor);
    this.renderer.setStyle(this.elementRef.nativeElement, 'borderRadius', '8px');
    this.renderer.setStyle(this.elementRef.nativeElement, 'padding', '16px');
    this.renderer.setStyle(this.elementRef.nativeElement, 'display', 'flex');
    this.renderer.setStyle(this.elementRef.nativeElement, 'alignItems', 'center');
    this.renderer.setStyle(this.elementRef.nativeElement, 'gap', '12px');
  }
}
